import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ResponsiveFixersPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ResponsiveFixersPublicAPI> {
    const {
        extensionPublicAPI: {dataManipulation: extensionDataManipulation}
    } = publicMethodUtils

    return {
        methods: {
            responsiveFixers: {
                pinToSticky: {
                    migratePage: extensionDataManipulation('responsiveFixers.pinToSticky.migratePage')
                }
            }
        }
    }
}
